/* Imports */
import React from "react"
import { Youtube } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const YoutubePage = () => {
    const items = [
        {
            content: <Youtube src="https://www.youtube.com/watch?v=XEfDYMngJeE" />,
            code: '<Youtube src="https://www.youtube.com/watch?v=XEfDYMngJeE" />',
        },
    ]
    // src, width, height, aspectRatio
    const propsItems = [
        {
            name: "src",
            type: "String",
            example: "https://www.youtube.com/watch?v=33KKr1ZGSzg",
            required: "Yes",
        },
        {
            name: "width",
            type: "Number or String",
            example: "200",
            required: "No",
        },
        {
            name: "height",
            type: "Number or String",
            example: "30vw",
            required: "No",
        },
        {
            name: "aspectRatio",
            type: "String",
            example: "1",
            default: "16/9",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default YoutubePage
